import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class AddTeamAgentsForm {
  public users: string[] = [];

  public rules: { [key: string]: FormValidationFunction[] } = {
    users: [
      (v: string[]) => !!v.length || 'You have to select at least one user',
    ],
  };
}
